import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  events: [],
  loading: false,
  error: null,
  filters: {
    childId: null,
    eventType: null,
    dateRange: null,
  },
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    hasMore: true,
  },
};

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    setEvents: (state, action) => {
      state.events = action.payload;
      state.loading = false;
      state.error = null;
    },
    addEvent: (state, action) => {
      const event = action.payload;
      const existingIndex = state.events.findIndex(e => e.id === event.id);
      
      if (existingIndex === -1) {
        // Add new event at the beginning (most recent first)
        state.events.unshift(event);
      } else {
        // Update existing event
        state.events[existingIndex] = event;
      }
    },
    updateEvent: (state, action) => {
      const { id, changes } = action.payload;
      const eventIndex = state.events.findIndex(e => e.id === id);
      
      if (eventIndex !== -1) {
        state.events[eventIndex] = { ...state.events[eventIndex], ...changes };
      }
    },
    removeEvent: (state, action) => {
      const eventId = action.payload;
      state.events = state.events.filter(event => event.id !== eventId);
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {
        childId: null,
        eventType: null,
        dateRange: null,
      };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    appendEvents: (state, action) => {
      const newEvents = action.payload;
      const existingIds = new Set(state.events.map(e => e.id));
      const uniqueNewEvents = newEvents.filter(event => !existingIds.has(event.id));
      
      state.events.push(...uniqueNewEvents);
      state.loading = false;
    },
    resetEvents: (state) => {
      state.events = [];
      state.pagination = {
        page: 1,
        limit: 20,
        total: 0,
        hasMore: true,
      };
    },
  },
});

export const {
  setLoading,
  setError,
  clearError,
  setEvents,
  addEvent,
  updateEvent,
  removeEvent,
  setFilters,
  clearFilters,
  setPagination,
  appendEvents,
  resetEvents,
} = eventsSlice.actions;

export default eventsSlice.reducer;